import { RestSchemas } from '@/contexts/QueryProvider'

type AppTypes = RestSchemas['DataModellingPlatform.Common.AppTypes']

export enum AppTypesEnum {
  'None' = 0,
  'Databricks' = 1,
  'Dagster' = 2,
  'Jupyter Hub' = 4,
}

export const AppTypesArray = [
  { roleId: 0, roleName: 'None', roleDescription: 'Normal Python app only' },
  { roleId: 1, roleName: 'Databricks', roleDescription: 'Databricks enabled.' },
  { roleId: 2, roleName: 'Dagster', roleDescription: 'Dagster enabled.' },
  { roleId: 4, roleName: 'Jupyter Hub', roleDescription: 'Jupyter Hub enabled.' },
]

export const deriveAppTypesNamesFromAppTypesNumber = (appTypesNumber: number) => {
  const appTypes = []
  if ((appTypesNumber & 1) > 0) appTypes.push(AppTypesArray[0].roleName)
  if ((appTypesNumber & 2) > 0) appTypes.push(AppTypesArray[1].roleName)
  if ((appTypesNumber & 4) > 0) appTypes.push(AppTypesArray[2].roleName)
  return appTypes
}

export const deriveAppTypesIdsFromAppTypesNumber = (appTypesNumber: number) => {
  const appTypes = []
  if ((appTypesNumber & 1) > 0) appTypes.push(1)
  if ((appTypesNumber & 2) > 0) appTypes.push(2)
  if ((appTypesNumber & 4) > 0) appTypes.push(4)
  return appTypes
}

export const deriveAppTypesNumberFromAppTypesIds = (appTypesIds: number[]): AppTypes => {
  return appTypesIds.reduce((acc, appTypeId) => acc | appTypeId, 0) as AppTypes
}

export const isDatabricksApp = (appTypesNumber: number): boolean => (appTypesNumber & AppTypesEnum['Databricks']) > 0
export const isDagsterApp = (appTypesNumber: number): boolean => (appTypesNumber & AppTypesEnum['Dagster']) > 0
export const isJupyterApp = (appTypesNumber: number): boolean => (appTypesNumber & AppTypesEnum['Jupyter Hub']) > 0

export function isValidAppTypes(value: number): value is AppTypesEnum {
  const validAppTypes = [0, 1, 2, 4]
  // Check if the value is a valid combination of the allowed appTypes
  return validAppTypes.reduce((acc, appType) => acc && (value & ~appType) >= 0, true)
}
